import { render, staticRenderFns } from "./ol-block.vue?vue&type=template&id=661f13e5&scoped=true&"
import script from "./ol-block.vue?vue&type=script&lang=js&"
export * from "./ol-block.vue?vue&type=script&lang=js&"
import style0 from "./ol-block.vue?vue&type=style&index=0&id=661f13e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661f13e5",
  null
  
)

export default component.exports